import enUS from 'antd/es/locale/en_US';

export default enUS;
